import { motion } from 'framer-motion';
const ErrorPage = () => {
  return (
    <motion.div
      initial={{ width: 0 }}
      animate={{ width: '100%' }}
      exit={{ x: window.innerWidth, transition: { duration: 0.3 } }}
    >
      <h1 className="text-center">Error Page Not Found!</h1>
    </motion.div>
  );
};

export default ErrorPage;
